export const RAK_VALUE_PACKAGE_PATH = "prospect.applicationInfo.rakValuePackage";
